import clsx from "clsx";
import React from "react";
import { DropdownField, Label } from "@trainline/depot-web";
import * as styles from "./TimePreferencePicker.module.css";
const TimePreferencePicker = ({
  name,
  id,
  label,
  labelFor,
  onChange,
  options,
  value,
  isRouteATOC
}) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx(styles.root, { [styles.routeAtoc]: isRouteATOC })
  }, isRouteATOC ? /* @__PURE__ */ React.createElement(DropdownField, {
    testId: "time-preference-picker",
    name,
    id,
    label,
    hideLabel: true,
    items: options,
    value,
    onChange
  }) : /* @__PURE__ */ React.createElement(Label, {
    htmlFor: labelFor,
    className: styles.label
  }, label));
};
var TimePreferencePicker_default = TimePreferencePicker;
export {
  TimePreferencePicker_default as default
};
